<template>
  <b-modal
    id="update-user-modal"
    title="Edit User"
    @ok="onConfirm"
    @show="$nextTick(populate)"
    ok-title="Save"
  >
    <b-form-group label="First Name">
      <b-form-input v-model="form.first_name" />
    </b-form-group>
    <b-form-group label="Last Name">
      <b-form-input v-model="form.last_name" />
    </b-form-group>
    <b-form-group label="Email">
      <b-form-input v-model="form.email" type="email" />
    </b-form-group>
    <b-form-group label="Race">
      <b-form-select v-model="form.race_uuid" :options="raceOptions" />
    </b-form-group>
    <b-form-group label="Role">
      <b-form-select v-model="form.role" :options="roleOptions" />
    </b-form-group>
  </b-modal>
</template>

<script>
const ROLES = ["admin", "staff", "volunteer"];

export default {
  name: "UpdateUserModal",
  props: {
    user: { type: Object, default: null },
  },
  data() {
    return {
      form: { first_name: "", last_name: "", email: "", race_uuid: null, role: null },
    };
  },
  computed: {
    raceOptions() {
      const races = this.$store.state.racesStore.availableRaces || [];
      return [
        { value: null, text: "No race" },
        ...races.map((r) => ({ value: r.uuid, text: r.short_name })),
      ];
    },
    roleOptions() {
      return [
        { value: null, text: "No role" },
        ...ROLES.map((r) => ({ value: r, text: r })),
      ];
    },
  },
  methods: {
    populate() {
      if (!this.user) return;
      const race = (this.$store.state.racesStore.availableRaces || []).find(
        (r) => r.short_name === this.user.assigned_race
      );
      this.form = {
        first_name: this.user.first_name || "",
        last_name: this.user.last_name || "",
        email: this.user.email || "",
        race_uuid: race ? race.uuid : null,
        role: this.user.primary_group || null,
      };
    },
    onConfirm() {
      const payload = {};
      if (this.form.first_name) payload.first_name = this.form.first_name;
      if (this.form.last_name) payload.last_name = this.form.last_name;
      if (this.form.email) payload.email = this.form.email;
      if (this.form.race_uuid !== undefined) payload.race_uuid = this.form.race_uuid;
      if (this.form.role) payload.role = this.form.role;
      this.$emit("confirm", payload);
    },
  },
};
</script>
